import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { InfoblockActions } from '../actions';
import { InfoblockState } from '../infoblock-state';
import { reducer as infoblockReducer } from './infoblock.reducers';

export function getReducers(): ActionReducerMap<InfoblockState> {
  return {
    items: StateUtils.entityLoaderReducer(InfoblockActions.INFOBLOCK),
    closed: infoblockReducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<InfoblockState>> = new InjectionToken<
  ActionReducerMap<InfoblockState>
>('InfoblockReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
